var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "country__wrapper" },
    [
      _c(
        _vm.link ? "nuxt-link" : "div",
        {
          tag: "component",
          staticClass: "country",
          class: {
            state: _vm.isState,
            "not-active": _vm.notActive,
          },
          attrs: { to: _vm.link },
        },
        [
          _c("div", { class: `country__icon-${_vm.size}` }, [
            _c("img", { attrs: { src: _vm.flagIcon, alt: _vm.text } }),
            _vm._v(" "),
            _vm.text && _vm.size !== "verysmallpadded"
              ? _c("span", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.text)),
                ])
              : _c("span", { staticClass: "verysmallcaption" }, [
                  _vm._v(_vm._s(_vm.text)),
                ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }